function getQuantityLabelCount({count}) {
    return `${count || 0}`;
}

function getQuantityLabelTerm({count, singular, plural, zero}) {
    if (count === 0) {
        return `${zero}`;
    }
    return count === 1 ? `${singular}` : `${plural}`;
}

function getQuantityLabel({count, singular, plural, locale, zero}) {
    const labelCount = getQuantityLabelCount({count});
    const labelTerm = getQuantityLabelTerm({count, singular, plural, zero});

    if (labelTerm === 'undefined') {
        return '';
    }

    if (locale === 'ja_JP') {
        const addendum = '名';
        return `${labelTerm} ${labelCount} ${addendum}`;
    }

    return `${labelCount} ${labelTerm}`;
}

function toString(value) {
    return String(value);
}

export {
    getQuantityLabelCount,
    getQuantityLabelTerm,
    getQuantityLabel,
    toString
};
